// Reusable US Letter VICS Master BOL (consolidator, commodity summary + supplement pages).
// Generated by scripts/wms/generate.ts for PHP-421. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomVicsMasterBillOfLadingFileDataSchema = yup.object().shape({
  bolDate: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  shipFromName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  shipFromCityStateZip: yup.string().nullable().optional(),
  shipFromSid: yup.string().nullable().optional(),
  consolidatorName: yup.string().nullable().optional(),
  consolidatorLocationNumber: yup.string().nullable().optional(),
  consolidatorAddress: yup.string().nullable().optional(),
  consolidatorCityStateZip: yup.string().nullable().optional(),
  consolidatorCid: yup.string().nullable().optional(),
  consolidatorScac: yup.string().nullable().optional(),
  consolidatorAuthNumber: yup.string().nullable().optional(),
  billTo: yup.object().shape({
    billToName: yup.string().nullable().optional(),
    billToAddress: yup.string().nullable().optional(),
    billToCityStateZip: yup.string().nullable().optional(),
  }),
  specialInstructions: yup.string().nullable().optional(),
  carrierName: yup.string().nullable().optional(),
  trailerNumber: yup.string().nullable().optional(),
  sealNumbers: yup.string().nullable().optional(),
  headerBarcode: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  freightChargeTerms: yup.string().nullable().optional(),
  masterBolIndicator: yup.string().nullable().optional(),
  feeTermsCollect: yup.string().nullable().optional(),
  feeTermsPrepaid: yup.string().nullable().optional(),
  customerCheckAcceptable: yup.string().nullable().optional(),
  trailerLoadedByShipper: yup.string().nullable().optional(),
  trailerLoadedByDriver: yup.string().nullable().optional(),
  freightCountedByShipper: yup.string().nullable().optional(),
  freightCountedByDriverPallets: yup.string().nullable().optional(),
  freightCountedByDriverPieces: yup.string().nullable().optional(),
  aggregatePackageCount: yup.string().nullable().optional(),
  aggregateWeight: yup.string().nullable().optional(),
  aggregateHandlingUnits: yup.string().nullable().optional(),
  handlingUnitType: yup.string().nullable().optional(),
  packageType: yup.string().nullable().optional(),
  commodityDescriptions: yup
    .array()
    .of(
      yup.object().shape({
        commodityDescription: yup.string().nullable().optional(),
        nmfcNumber: yup.string().nullable().optional(),
        freightClass: yup.string().nullable().optional(),
      }),
    )
    .required(),
  codAmount: yup.string().nullable().optional(),
  shipperSignature: yup.string().nullable().optional(),
  carrierSignature: yup.string().nullable().optional(),
  customerOrderRows: yup
    .array()
    .of(
      yup.object().shape({
        customerOrderNumber: yup.string().nullable().optional(),
        packageCount: yup.string().nullable().optional(),
        orderWeight: yup.string().nullable().optional(),
        palletSlip: yup.string().nullable().optional(),
        additionalShipperInfo: yup.string().nullable().optional(),
      }),
    )
    .required(),
  carrierInfoRows: yup
    .array()
    .of(
      yup.object().shape({
        handlingUnitQty: yup.string().nullable().optional(),
        handlingUnitType: yup.string().nullable().optional(),
        packageQty: yup.string().nullable().optional(),
        packageType: yup.string().nullable().optional(),
        rowWeight: yup.string().nullable().optional(),
        hazmat: yup.string().nullable().optional(),
        commodityDescription: yup.string().nullable().optional(),
        nmfcNumber: yup.string().nullable().optional(),
        freightClass: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomVicsMasterBillOfLadingFileData = yup.InferType<
  typeof biomVicsMasterBillOfLadingFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomVicsMasterBillOfLadingFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomVicsMasterBillOfLadingFileMappings: RequiredFileData = {
  bolDate: '17ebd1bc-6cf8-4324-98ff-224e95e8e06a',
  bolNumber: '91a2f94a-317a-41d9-b485-ee887fedf085',
  shipFromName: '97aca570-39b7-4637-b511-f249ccef7e4a',
  shipFromAddress: '29ddf281-ecb2-4bfa-bf15-709d2d1ea538',
  shipFromCityStateZip: 'ca62c210-b563-4831-8a58-a9299767c795',
  shipFromSid: 'e5ed4a74-96d9-495f-a40d-8ea0a60f2c2f',
  consolidatorName: '71d4da08-885e-49ed-8f22-baf7a7046799',
  consolidatorLocationNumber: '48b8f693-fed7-40ff-9888-c6763e2aec9c',
  consolidatorAddress: 'ee64b44b-4e3a-42b3-966d-2394716e0b68',
  consolidatorCityStateZip: 'cbe32a1c-6515-4d4f-a89c-e8ccd3c9dd63',
  consolidatorCid: 'f5e237e1-2fd1-4cc3-a73a-d1b2e1b46998',
  consolidatorScac: '0f92537d-2af1-41e6-b143-abc1e4bace31',
  consolidatorAuthNumber: '370dd9e4-72b5-4314-bd27-1c4ff46af4b6',
  billTo: {
    billToName: '9e360835-7a20-41d1-9a43-3e3da02188d7',
    billToAddress: 'ac9c40a6-1099-4559-a9e7-e48ea315e99c',
    billToCityStateZip: '036a89fe-6ef7-44b2-aab5-a9020a367902',
  },
  specialInstructions: '78c9937e-1129-4b86-9afe-e9f33b687c6b',
  carrierName: 'dfdbdc0d-d71f-4b69-9573-1e5af578374e',
  trailerNumber: 'aeee8dfb-07d1-415b-9511-16498b0e3a2b',
  sealNumbers: '75f92e9e-cc8a-4196-af2d-8be843585a4e',
  headerBarcode: 'f3bae0a0-6afa-45dc-8169-36e1b8bdb8be',
  weightUom: 'e85b3b5b-d9ba-4b02-952b-ab9a8f34d066',
  freightChargeTerms: '3d2cb4ea-b25d-492f-94e1-b4c0a944984c',
  masterBolIndicator: '9c893f53-e4f7-444a-8de0-cdc6cde136c9',
  feeTermsCollect: '89937bba-c2b6-4c54-9b83-32ca578e0ac9',
  feeTermsPrepaid: '171ab8b2-88af-406f-82ba-bf4ec59d6708',
  customerCheckAcceptable: '72f40aaf-0d7b-46dc-9459-f18c8ca09d2f',
  trailerLoadedByShipper: 'eb19bb12-919c-4f31-acd7-6f903997a9f3',
  trailerLoadedByDriver: 'f0158712-3d38-4e2f-bcbb-973c5cd62c66',
  freightCountedByShipper: '1f80ff86-165d-4a6a-96c0-b50d9550c398',
  freightCountedByDriverPallets: '1e6f5473-14e6-4b61-a565-1a91c1d880d6',
  freightCountedByDriverPieces: '98615151-f004-48d7-be68-d546e3a05f9c',
  aggregatePackageCount: '7af9a8a4-5f25-42b9-894a-7962480e9ee7',
  aggregateWeight: '731bc19e-135b-4d38-b881-5a2fce748ab9',
  aggregateHandlingUnits: '06e1a188-42c2-4bd8-9ff4-5a12e1b509a8',
  handlingUnitType: '9b1e0620-9cfd-452e-b028-00f883889e00',
  packageType: '4907d009-a950-4f35-bb1f-fea8e107bb48',
  commodityDescriptions: [
    {
      commodityDescription: '1b85ddae-d786-4504-9e81-cdf5f1a24203',
      nmfcNumber: '99e5d4e6-a7fe-4427-93b7-b9c409a1ae40',
      freightClass: '0e880893-6101-4653-8cb3-94e0bd07f5bb',
    },
  ],
  codAmount: 'd9f7c50c-cd46-4890-9471-79afad8a4aa3',
  shipperSignature: 'e5c6d651-067d-4796-a05d-46acb2605874',
  carrierSignature: '3517f4e1-a7c8-4963-8d75-60ac92f90726',
  customerOrderRows: [
    {
      customerOrderNumber: '16c43be9-8942-4ddb-8c2e-c5124f1fc439',
      packageCount: 'e81d57b1-cee3-4b68-bae1-522ce7585834',
      orderWeight: '62a77aab-c494-45bc-9a05-5d706b1f2922',
      palletSlip: 'b5ece2f7-c0f7-4edb-9a2e-91914a902ff5',
      additionalShipperInfo: '86ac8d7c-8862-47aa-ba28-8c822abd18b4',
    },
  ],
  carrierInfoRows: [
    {
      handlingUnitQty: '6ebf427e-033d-467c-9279-fefac09204f6',
      handlingUnitType: 'e4c65715-fc9f-4403-a896-d7fd8668f6e6',
      packageQty: 'd2afd3dc-07db-45db-8713-0f6ea16baf5e',
      packageType: '9f59f70e-9eeb-4821-b290-bcab43b02238',
      rowWeight: '403f3fb5-a2da-4516-8fed-303bcfdfe763',
      hazmat: '7e0d0bf6-624b-472e-a6b6-7f9e86889950',
      commodityDescription: 'b3283dff-467b-4830-9be4-edd62e29e4b4',
      nmfcNumber: 'ab676f7a-e01c-488c-854a-8f4f613efcad',
      freightClass: '88167fda-be02-4ec7-b6e3-b68bfa54482f',
    },
  ],
}
